import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

export const logoutService = async (baseURL, requestBody) => {
  try {
    const logginResp = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.logout}?userId=${requestBody?.userId}`
    );
    if (logginResp?.status === 200 && logginResp.data) {
      localStorage.removeItem("DAS_VENDOR_INTERNAL_STATE");
      if (
        !!requestBody &&
        !!requestBody?.id_token &&
        !!requestBody?.id_token !== ""
      ) {
        window.location.href = `${process.env.REACT_APP_LOGOUT_REDIRECT_URL}/oidc/logout?id_token_hint=${requestBody?.id_token}&post_logout_redirect_uri=${process.env.REACT_APP_BASE_URL}`;
      }
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
